<template>
  <b-modal
    id="simple-image-popup"
    ref="simple-image-popup"
    class="home_event_modal"
    centered
    scrollable
    hide-header
    hide-footer
    body-class="p-0"
  >
    <div class="sip_klay_content">
      <div class="img_box" @click="openLink()">
        <img src="/img/threespace/event/event-yeoksam.png" />
      </div>
    </div>
    <div class="event-modal-btn-wrap">
      <div class="not_seen_week_btn" @click="onClickNotSeenBtn()">{{ $t("nftpool.artpoolGallery.doNotShow") }}</div>
      <div @click="hide">{{ $t("button.close") }}</div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "SimpleImagePopup",
  data() {
    return {
      arrowColor: "#000",
      openWinnerList: false
    };
  },
  methods: {
    show() {
      this.$refs["simple-image-popup"].show();
    },
    hide() {
      this.$refs["simple-image-popup"].hide();
    },
    openLink() {
      window.open("https://www.instagram.com/3space.art/", "_blank");
    },
    onClickWhitelist() {
      window.open("https://gleam.io/rYVNT/ordinals-airdrops-follow-3space-art", "_blank");
    },
    onClickExplore() {
      window.open("https://3space.art/ordinals", "_blank");
    },
    onClickNotSeenBtn() {
      this.$emit("onClickPopupNoneSeenWeekBtn", 12);
    },
  }
};
</script>

<style scoped>


.event-modal-btn {
  padding: 20px 0;
  flex: 1;
  font-size: 25px;
  font-family: 'Jost';
  color: #030405;
  font-weight: 500;
  border-radius: 0;
  text-align: center;
  cursor: pointer;
}

.event-modal-btn:first-child {
  border-right: 2px solid #05080C;
}
.event-modal-btn-wrap {
  display:flex;
  justify-content: space-between;
  padding: 10px 20px;
  color: #111111;
  font-weight: 600;
  font-family: "Pretendard";
}
.event-modal-btn-wrap div {
  cursor: pointer;
}

.sip_klay_content {
  background-color:#000000;
  position: relative;
  overflow: hidden;
}
.sip_klay_content .close_btn {
  position: absolute;
  color:#ffffff;
  top: 12px;
  right: 20px;
  font-size:24px;
  cursor: pointer;
  z-index: 999;
}

.sip_klay_content .close_btn img {
  width: 20px;
  height: 20px;
}

.sip_klay_content .none_seen_week_btn {
  text-align:center;
  margin: 0 auto;
  width:150px;
  color: #ffffff;
  padding:10px;
  border:1px solid #ffffff;
  cursor:pointer;
}

.sip_klay_content .img_box {
  width: 100%;
  height: auto;
}
.sip_klay_content .img_box img{
  width: 100%;
  height: auto;
}

.sip_klay_content .text {
  text-align:center;
  color:#ffffff;
  background-color:#000000;
  padding: 0 10% 10px;
  font-size:14px;
  word-break:keep-all;
}

.sip_klay_content .text-big {
  font-size:24px;
  margin-bottom:10px;
}
</style>
